import * as ActionTypes from 'actions/Organizations';
import * as AuthActionTypes from 'actions/Auth';
import { get } from 'lodash';

const initialState = {
  organizationList: [],
  activeOrgs: [],
  inactiveOrgs: [],
  organizationsHierarchy: [],
  organization: null,
  organizationTypes: [],
  organizationListPage: 0,
  activeOrgsPage: 0,
  inactiveOrgsPage: 0,
  childMembersTableFilter: '',
  childUsersTableFilter: '',
  tableFilter: {},
  tableSorting: {},
  assignOrgModalOpen: false,
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGOUT.SUCCESS:
      return { ...initialState };
    case ActionTypes.SET_ORGANIZATION_TABLE_FILTER:
      return { ...state, tableFilter: action.payload };
    case ActionTypes.SET_ORGANIZATION_TABLE_SORTING:
      return { ...state, tableSorting: action.payload };
    case ActionTypes.SET_CHILD_MEMBERS_TABLE_FILTER:
      return { ...state, childMembersTableFilter: action.payload };
    case ActionTypes.SET_CHILD_USERS_TABLE_FILTER:
      return { ...state, childUsersTableFilter: action.payload };
    case ActionTypes.GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        organizationList: get(action.payload, 'content'),
        organizationListPage: get(action, 'payload.currentPage', 0),
        organizationListPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_ACTIVE_ORGANIZATIONS.SUCCESS:
      return {
        ...state,
        activeOrgs: get(action.payload, 'content'),
        activeOrgsPage: get(action, 'payload.currentPage', 0),
        activeOrgsPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_INACTIVE_ORGANIZATIONS.SUCCESS:
      return {
        ...state,
        inactiveOrgs: get(action.payload, 'content'),
        inactiveOrgsPage: get(action, 'payload.currentPage', 0),
        inactiveOrgsPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_ORGANIZATION_HIERARCHY.SUCCESS:
      return { ...state, organizationsHierarchy: action.payload };
    case ActionTypes.GET_ORGANIZATION.SUCCESS:
      return {
        ...state,
        organization: action.payload,
      };
    case ActionTypes.GET_CHILD_ORGANIZATION.SUCCESS:
      return {
        ...state,
        childOrganization: action.payload,
      };
    case ActionTypes.GET_ORGANIZATION_TYPES.SUCCESS:
      return {
        ...state,
        organizationTypes: action.payload,
      };
    case ActionTypes.TOGGLE_ASSIGN_ORG_MODAL:
      return {
        ...state,
        assignOrgModalOpen: action.payload,
      };
    default:
      return state;
  }
}
